import { all, call, put, fork, takeEvery } from 'redux-saga/effects';
import { fetchSurveyQuestionsSuccess, showSurveyQuestionMessage } from 'actions/SurveyQuestion';
import { FETCH_ALL_SURVEY_QUESTION } from 'constants/ActionTypes';
import { fetchDataRequest } from 'services/ApiService';

const fetchSurveyQuestionsRequest = async () => {
    return fetchDataRequest('surveyQuestions');
};

function* fetchSurveyQuestions() {
    try {
        const fetchedSurveyQuestions = yield call(fetchSurveyQuestionsRequest) || [];
        yield put(fetchSurveyQuestionsSuccess(fetchedSurveyQuestions));
    } catch (error) {
        yield put(showSurveyQuestionMessage(error.messages));
    }
}

export function* fetchSurveyQuestionsSaga() {
    yield takeEvery(FETCH_ALL_SURVEY_QUESTION, fetchSurveyQuestions);
}

export default function* rootSaga() {
    yield all([fork(fetchSurveyQuestionsSaga)]);
}


// WEBPACK FOOTER //
// ./sagas/SurveyQuestion.js